import './wdyr';
import './instrument';
import { ColorModeScript } from '@chakra-ui/react';
import * as React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import reportWebVitals from './reportWebVitals';
import * as serviceWorker from './serviceWorker';
import { Provider } from 'react-redux';
import store from './store';
import './index.css';
import FlagProvider from '@unleash/proxy-client-react';
import { HashRouter } from 'react-router-dom';

const config = {
  url: `${process.env.REACT_APP_FEATURE_FLAG_URL}/proxy`,
  clientKey: 'beekin-secret',
  refreshInterval: 60,
  metricsInterval: 60,
  appName: process.env.REACT_APP_TYPE,
  environment: process.env.REACT_APP_TYPE,
};

ReactDOM.render(
  <React.StrictMode>
    <FlagProvider config={config}>
      <ColorModeScript />
      <Provider store={store}>
        <HashRouter>
          <App />
        </HashRouter>
      </Provider>
    </FlagProvider>
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
serviceWorker.unregister();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
